$(".why-ten-performance-slider").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          arrows: true,
          centerPadding: '10px',
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerPadding: '10px',
          slidesToShow: 1,
          arrows: true,
          slidesToScroll: 1,
        },
      },
    ],
  });

